import api from '@/api'

const namespaced = true

const state = {
  bargeCapacities: [],
  bargeCapacityFiles: {}
}

const getters = {
  bargeCapacities: state => state.bargeCapacities,
  bargeCapacityFiles: state => state.bargeCapacityFiles
}

const mutations = {
  SET_BARGE_CAPACITIES: (state, payload) => {
    state.bargeCapacities = payload
  },
  SET_BARGE_CAPACITY_FILES: (state, payload) => {
    state.bargeCapacityFiles = payload
  }
}

const actions = {
  async fetchBargeCapacities({ commit, rootGetters }, payload) {
    try {
      const { search } = rootGetters['Table/defaultConfig']
      const { data } = await api.getBargeCapacities({ ...payload, search: search })
      if (!data.error) {
        commit('SET_BARGE_CAPACITIES', data)
      }
    } catch (err) {
      throw err
    }
  },
  async downloadBargeCapacities({ commit }, payload) {
    try {
      const response = await api.downloadBargeCapacities(payload)
      if (response) {
        commit('SET_BARGE_CAPACITY_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetBargeCapacities({ commit }) {
    commit('SET_BARGE_CAPACITY_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }
